import { Competition } from './competition';

export class Section {
	id: string;
	horse_show_id: string;
	number: number;
	name: string;
	type: string;
	entry_fee: number;
	fee_option: string;
	usef_section_code: string;
	ec_section_code: string;
	qualifying: boolean;
	entry_form_alias: string;
	user_id: string;
	restrict_entry: boolean;
	competition_list: Competition[];

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}